module.exports = __webpack_public_path__ + "static/ana_circle-1fd844f02a8c21f0c38fa413db1f1b7f.png";